import React from 'react';
import { createNewProject as createNewProjectWithPath } from '../../../../pages/Tools/uploadHelper';
import { createNewProject as createNewProjectWithNoPath } from '../../../../pages/SubtitlesTranscription/SubtitlesTranscriptionHelper';
import { useDashboardToolsData } from './dashboardToolsData';
import { Box, Typography, useTheme } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import './dashboardTools.scss';

const handleCreateProject = (path) => {
  if (path) {
    createNewProjectWithPath(path);
  } else {
    createNewProjectWithNoPath();
  }
}

export const DashboardTools = () => {
  const theme = useTheme();
  const toolsArr = useDashboardToolsData();
  return (
    <Box className='dashboard-tools-wrapper'>
      {toolsArr.map(tool => {
        return (
          <Box className={`tool-card ${theme.palette.mode === 'dark' ? 'dark' : 'light'}`} onClick={() => handleCreateProject(tool.path)}>
            <Box className='image' component={'img'} src={tool.image} />
            <Typography className='name'>{tool.name}
              <ChevronRightIcon />
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}
